import { faClipboard } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  CloseButton,
  Group,
  PillsInput as MantinePillsInput,
  Pill,
  useCombobox,
} from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { InputField, PillList } from './components';
import { PillsInputSharePropsType, PillsInputViewPropsType } from './types';

const RIGHT_SECTION_WIDTH_TWO = 50;

type PillsInputPropsType = PillsInputViewPropsType &
  PillsInputSharePropsType & {
  ref?: React.Ref<HTMLDivElement>;
  combobox: ReturnType<typeof useCombobox>;
  inputRef: React.RefObject<HTMLInputElement | null>;
};

export const PillsInput: React.FC<PillsInputPropsType> = ({
  ref,
  combobox,
  inputRef,
  pills,
  search,
  showInvalidHint,
  isDragDisabled,
  onClearAll,
  onRemovePillAtIndex,
  onReorderPills,
  onPillClick,
  onSearchChange,
  onEnterCommit,
  onShare,
  isShareDisabled,
}) => {
  const { t } = useTranslation();

  const handleRemoveLastPill = () => {
    if (pills.length === 0) return;

    onRemovePillAtIndex(pills.length - 1);
  };

  return (
    <MantinePillsInput
      ref={ref}
      error={showInvalidHint}
      onClick={() => {
        combobox.openDropdown();
      }}
      rightSection={
        <Group gap={4}>
          <CloseButton
            aria-label={t('QUERY_BUILDER.SHARE')}
            disabled={isShareDisabled}
            icon={<FontAwesomeIcon icon={faClipboard} />}
            onClick={onShare}
            size="sm"
          />

          <CloseButton
            aria-label={t('QUERY_BUILDER.CLEAR')}
            onClick={onClearAll}
            size="sm"
          />
        </Group>
      }
      rightSectionPointerEvents="all"
      rightSectionWidth={RIGHT_SECTION_WIDTH_TWO}
    >
      <Pill.Group>
        <PillList
          pills={pills}
          isDragDisabled={isDragDisabled}
          onRemovePillAtIndex={onRemovePillAtIndex}
          onReorderPills={onReorderPills}
          onPillClick={onPillClick}
        />

        <InputField
          inputRef={inputRef}
          combobox={combobox}
          search={search}
          hasPills={pills.length > 0}
          onSearchChange={onSearchChange}
          onEnterCommit={onEnterCommit}
          onRemoveLastPill={handleRemoveLastPill}
        />
      </Pill.Group>
    </MantinePillsInput>
  );
};
